import React, { useState, useEffect, useMemo } from 'react';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Financials from './Financials';

const initialFinanceState = {
    revenue: 0,
    expenses: 0,
    cmTotal: 0,
    cmPercent: 0
}

const FinancialInfo = (props) => {
    const [financials, setFinancials] = useState(initialFinanceState);

    const getFinancials = () => {

        const orders = props.orders.state.sortedData;

        const remCommas = dollarValue => (dollarValue ? dollarValue.replace(/\$|,/g, '') : '');
        const commaFy = (dollarValue) => (dollarValue ? dollarValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '');
        const restrictDecimals = (f) => f.toFixed(2);

        let revenue = 0;
        let expenses = 0;

        for (let i = 0; i < orders.length; i++) {
            if (orders[i].totalRevenue) revenue += parseFloat(remCommas(typeof orders[i].totalRevenue === 'string' ? orders[i].totalRevenue : orders[i].totalRevenue.toString()));
            if (orders[i].tripRate) expenses += parseFloat(remCommas(typeof orders[i].tripRate === 'string' ? orders[i].tripRate : orders[i].tripRate.toString()));
        }


        revenue = revenue.toFixed(2);
        expenses = expenses.toFixed(2);
        console.log(revenue, expenses)
        const contribution = (revenue - expenses).toFixed(2);
        console.log(commaFy(contribution))
        const contributionPercent = ((contribution / revenue) * 100).toFixed(2);
        console.log(contributionPercent)

        setFinancials({
            revenue: commaFy(revenue),
            expenses: commaFy(expenses),
            contribution: commaFy(contribution),
            contributionPercent
        })
    }

    useEffect(getFinancials, [props]);

    return (
        <GridContainer justify='space-around' alignItems='flex-end'>
            <GridItem xs={6} sm>
                <Financials
                    name='# of Trips'
                    val={props.orders.state.sortedData.length}
                />
            </GridItem>
            <GridItem xs={6} sm>
                <Financials
                    name='Filtered Revenue'
                    type='revenue'
                    val={financials.revenue}
                />
            </GridItem>
            <GridItem xs={6} sm>
                <Financials
                    name='Filtered Expenses'
                    type='expense'
                    val={financials.expenses}
                />
            </GridItem>
            <GridItem xs={6} sm>
                <Financials
                    name='Filtered Contribution'
                    type='revenue'
                    val={financials.contribution}
                />
            </GridItem>
            <GridItem xs={6} sm>
                <Financials
                    name='Filtered Contribution Percent'
                    type='percent'
                    val={financials.contributionPercent}
                />
            </GridItem>
        </GridContainer>
    );
}

export default FinancialInfo;


// WEBPACK FOOTER //
// ./src/components/TripFinancials/index.jsx